/* ==========================================================================
   RENACE LABS — comportamiento de las secciones
   Todo se inicializa por data-attributes y es idempotente:
   funciona con carga normal y con los eventos del editor de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  // Cada sección incluye el <script>. Si ya se ejecutó una vez, salimos:
  // así podés dejar los renders por sección o mover el asset a theme.liquid.
  if (window.RenaceLabs) return;

  var init = {};

  /* ---------------------------------------------------- header sticky ---- */
  init.header = function (root) {
    root.querySelectorAll('[data-rl-header]').forEach(function (header) {
      if (header.dataset.rlReady) return;
      header.dataset.rlReady = '1';

      var burger = header.querySelector('[data-rl-burger]');
      if (burger) {
        burger.addEventListener('click', function () {
          var open = header.classList.toggle('is-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      var onScroll = function () {
        header.classList.toggle('is-stuck', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  };

  /* ------------------------------------------ desplegables del menú ------ */
  init.dropdown = function (root) {
    var isDesktop = function () { return window.matchMedia('(min-width: 901px)').matches; };

    root.querySelectorAll('[data-rl-dropdown]').forEach(function (item) {
      if (item.dataset.rlReady) return;
      item.dataset.rlReady = '1';

      var toggle = item.querySelector('.rl-nav__toggle');
      var panel = item.querySelector('.rl-nav__panel');
      if (!toggle || !panel) return;

      var open = function (state) {
        item.classList.toggle('is-open', state);
        toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
        panel.hidden = !state;
      };

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        // En desktop el hover ya lo abrió: si el clic alternara, cerraría el
        // panel justo cuando el usuario va a elegir una opción. Ahí el clic
        // solo abre y el cierre queda a cargo del mouseleave o del clic fuera.
        if (isDesktop()) open(true);
        else open(panel.hidden);
      });

      // En desktop además abre al pasar el mouse. El ::before del panel cubre
      // el hueco entre el botón y el panel para que no se cierre al cruzarlo.
      item.addEventListener('mouseenter', function () { if (isDesktop()) open(true); });
      item.addEventListener('mouseleave', function () { if (isDesktop()) open(false); });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { open(false); toggle.focus(); }
      });

      document.addEventListener('click', function (e) {
        if (!item.contains(e.target) && !panel.hidden) open(false);
      });
    });
  };

  /* ------------------------------------------------ buscador del header -- */
  init.search = function (root) {
    root.querySelectorAll('[data-rl-search]').forEach(function (box) {
      if (box.dataset.rlReady) return;
      box.dataset.rlReady = '1';

      var header = box.closest('[data-rl-header]') || document;
      var toggle = header.querySelector('[data-rl-search-toggle]');
      var close = box.querySelector('[data-rl-search-close]');
      var input = box.querySelector('input[type="search"]');

      var show = function (state) {
        box.hidden = !state;
        if (toggle) toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
        if (state && input) input.focus();
      };

      if (toggle) toggle.addEventListener('click', function () { show(box.hidden); });
      if (close) close.addEventListener('click', function () { show(false); if (toggle) toggle.focus(); });
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { show(false); if (toggle) toggle.focus(); } });
    });
  };

  /* ------------------------------------------- rotador de anuncios ------- */
  init.announce = function (root) {
    root.querySelectorAll('[data-rl-announce]').forEach(function (bar) {
      if (bar.dataset.rlReady) return;
      bar.dataset.rlReady = '1';

      var items = bar.querySelectorAll('.rl-announce__item');
      if (items.length < 2) return;
      var speed = parseInt(bar.dataset.rlAnnounce, 10) || 4000;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  };

  /* ------------------------------------ marquesina: duplica el grupo ----- */
  init.marquee = function (root) {
    root.querySelectorAll('[data-rl-marquee]').forEach(function (m) {
      if (m.dataset.rlReady) return;
      m.dataset.rlReady = '1';

      var track = m.querySelector('.rl-marquee__track');
      var group = track && track.querySelector('.rl-marquee__group');
      if (!group) return;
      // Un clon exacto permite que translateX(-50%) haga el loop perfecto.
      track.appendChild(group.cloneNode(true));
    });
  };

  /* ------------------------------------------ video con placeholder ------ */
  init.video = function (root) {
    root.querySelectorAll('[data-rl-video]').forEach(function (box) {
      if (box.dataset.rlReady) return;
      box.dataset.rlReady = '1';

      var btn = box.querySelector('[data-rl-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var embed = box.dataset.rlEmbed;   // URL de iframe (YouTube/Vimeo)
        var native = box.querySelector('video');
        box.classList.add('is-playing');

        if (native) { native.controls = true; native.play(); return; }
        if (embed) {
          var iframe = document.createElement('iframe');
          iframe.src = embed + (embed.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.setAttribute('allowfullscreen', '');
          iframe.title = box.dataset.rlTitle || 'Video';
          box.appendChild(iframe);
        }
      });
    });
  };

  /* ------------------------------------------- selector de planes -------- */
  init.plans = function (root) {
    root.querySelectorAll('[data-rl-plans]').forEach(function (group) {
      if (group.dataset.rlReady) return;
      group.dataset.rlReady = '1';

      var plans = group.querySelectorAll('.rl-plan');
      var cta = document.getElementById(group.dataset.rlPlans || '');

      var select = function (plan) {
        plans.forEach(function (p) { p.classList.toggle('is-selected', p === plan); });
        var input = plan.querySelector('input');
        if (input) input.checked = true;
        if (cta && plan.dataset.rlUrl) cta.setAttribute('href', plan.dataset.rlUrl);
        if (cta && plan.dataset.rlCtaText) cta.textContent = plan.dataset.rlCtaText;
      };

      plans.forEach(function (plan) {
        plan.addEventListener('click', function () { select(plan); });
        plan.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(plan); }
        });
      });

      var pre = group.querySelector('.rl-plan.is-selected') || plans[0];
      if (pre) select(pre);
    });
  };

  /* ----------------------------------------------------------- FAQ ------- */
  init.faq = function (root) {
    root.querySelectorAll('[data-rl-faq]').forEach(function (faq) {
      if (faq.dataset.rlReady) return;
      faq.dataset.rlReady = '1';

      faq.querySelectorAll('.rl-faq__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.rl-faq__item');
          var open = item.classList.toggle('is-open');
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  };

  /* ------------------------------------------------ galería producto ----- */
  init.gallery = function (root) {
    root.querySelectorAll('[data-rl-gallery]').forEach(function (gal) {
      if (gal.dataset.rlReady) return;
      gal.dataset.rlReady = '1';

      var main = gal.querySelector('[data-rl-gallery-main] img');
      var slides = gal.querySelectorAll('.rl-pdp2__slide');
      var THUMBS = '.rl-pdp__thumb, .rl-pdp2__thumb';

      gal.querySelectorAll(THUMBS).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gal.querySelectorAll(THUMBS).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');

          // Galería nueva: las fotos ya están todas en el DOM y solo se
          // alterna cuál se ve. Así en celular la misma pista sirve de
          // carrusel deslizable sin duplicar el marcado.
          if (thumb.dataset.rlSlide !== undefined && slides.length) {
            var i = parseInt(thumb.dataset.rlSlide, 10);
            slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
            return;
          }

          // Galería vieja (rl-product-hero): se cambia el src de una sola foto.
          var img = thumb.querySelector('img');
          if (main && img) {
            main.src = img.dataset.rlFull || img.src;
            main.srcset = '';
            main.alt = img.alt || '';
          }
        });
      });
    });
  };

  /* ------------------------------- cantidad (comprá más, ahorrá más) ----- */
  init.tiers = function (root) {
    root.querySelectorAll('[data-rl-tiers]').forEach(function (group) {
      if (group.dataset.rlReady) return;
      group.dataset.rlReady = '1';

      var tiers = group.querySelectorAll('.rl-tier');
      var form = group.closest('form');
      var variantInput = form ? form.querySelector('[data-rl-variant-input]') : null;

      // El bloque de precio de arriba tiene que seguir al paquete elegido. Si no,
      // el cliente ve un precio y se le cobra otro.
      var scope = group.closest('[id^="shopify-section-"]') || document;
      var elNow = scope.querySelector('[data-rl-price-now]');
      var elWas = scope.querySelector('[data-rl-price-was]');
      var elOff = scope.querySelector('[data-rl-price-off]');

      var pintarPrecio = function (tier) {
        if (!elNow || !tier.dataset.rlNow) return;
        elNow.textContent = tier.dataset.rlNow;
        var hay = tier.dataset.rlHasoff === '1';
        if (elWas) {
          elWas.textContent = tier.dataset.rlWas || '';
          elWas.hidden = !hay;
        }
        if (elOff) {
          elOff.textContent = '-' + (tier.dataset.rlOff || 0) + '%';
          elOff.hidden = !hay;
        }
      };

      var select = function (tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
          var i = t.querySelector('input');
          if (i) i.checked = on;
        });
        var id = tier.dataset.rlVariant;
        if (variantInput && id) variantInput.value = id;
        pintarPrecio(tier);
      };

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () { select(tier); });
        tier.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(tier); }
        });
      });

      var pre = group.querySelector('.rl-tier.is-selected') || tiers[0];
      if (pre) select(pre);
    });
  };

  /* ------------------------------------ suscripción vs. compra única ----- */
  init.buybox = function (root) {
    root.querySelectorAll('[data-rl-buy]').forEach(function (group) {
      if (group.dataset.rlReady) return;
      group.dataset.rlReady = '1';

      var opts = group.querySelectorAll('.rl-buyopt');
      var select = function (opt) {
        opts.forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
          var i = o.querySelector('input');
          if (i) i.checked = on;
        });
      };

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () { select(opt); });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(opt); }
        });
      });
    });
  };

  /* --------------------------------------- acordeón de beneficios -------- */
  init.benefacc = function (root) {
    root.querySelectorAll('[data-rl-benefacc]').forEach(function (list) {
      if (list.dataset.rlReady) return;
      list.dataset.rlReady = '1';

      list.querySelectorAll('.rl-benefacc__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.rl-benefacc__item');
          var willOpen = !item.classList.contains('is-open');
          // Acordeón de a uno: abrir cierra el resto.
          list.querySelectorAll('.rl-benefacc__item').forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.rl-benefacc__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  };

  /* --------------------------------------------- barra móvil sticky ------ */
  init.stickybar = function (root) {
    root.querySelectorAll('[data-rl-stickybar]').forEach(function (bar) {
      if (bar.dataset.rlReady) return;
      bar.dataset.rlReady = '1';

      var onScroll = function () {
        bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  };

  /* ------------------------------------------- carrusel de GIFs ---------- */
  init.gifs = function (root) {
    root.querySelectorAll('[data-rl-gifs]').forEach(function (stage) {
      if (stage.dataset.rlReady) return;
      stage.dataset.rlReady = '1';

      var slides = Array.prototype.slice.call(stage.querySelectorAll('.rl-gifs__slide'));
      if (slides.length < 2) return;

      var dots = stage.parentNode.querySelectorAll('.rl-gifs__dot');
      var segundos = parseFloat(stage.dataset.interval) || 2.5;
      var actual = 0;

      window.setInterval(function () {
        slides[actual].classList.remove('is-active');
        if (dots[actual]) dots[actual].classList.remove('is-active');
        actual = (actual + 1) % slides.length;
        slides[actual].classList.add('is-active');
        if (dots[actual]) dots[actual].classList.add('is-active');
      }, segundos * 1000);
    });
  };

  /* ------------------------------------ puntos de los carruseles --------- */
  init.dots = function (root) {
    root.querySelectorAll('[data-rl-carousel]').forEach(function (track) {
      if (track.dataset.rlReady) return;
      track.dataset.rlReady = '1';

      var items = Array.prototype.slice.call(track.children);
      if (items.length < 2) return;

      var dots = document.createElement('div');
      dots.className = 'rl-dots';
      dots.setAttribute('role', 'tablist');

      items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
        b.addEventListener('click', function () {
          // scrollIntoView movería la página entera; scrollLeft solo la pista.
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });

      track.parentNode.insertBefore(dots, track.nextSibling);

      var marcar = function () {
        var centro = track.scrollLeft + track.clientWidth / 2;
        var activo = 0, min = Infinity;
        items.forEach(function (item, i) {
          var c = item.offsetLeft - track.offsetLeft + item.offsetWidth / 2;
          var d = Math.abs(c - centro);
          if (d < min) { min = d; activo = i; }
        });
        Array.prototype.forEach.call(dots.children, function (b, i) {
          b.classList.toggle('is-active', i === activo);
        });
      };

      track.addEventListener('scroll', function () {
        window.clearTimeout(track._rlDotTimer);
        track._rlDotTimer = window.setTimeout(marcar, 60);
      }, { passive: true });
      marcar();
    });
  };

  /* ------------------------------------------- reveal al hacer scroll ---- */
  init.reveal = function (root) {
    var nodes = root.querySelectorAll('.rl-reveal:not([data-rl-ready])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (n) { n.dataset.rlReady = '1'; io.observe(n); });
  };

  /* -------------------------------------------------------- arranque ----- */
  function boot(root) {
    root = root || document;
    Object.keys(init).forEach(function (k) {
      try { init[k](root); } catch (err) { console.warn('[renace] ' + k, err); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Editor de temas de Shopify: re-inicializa la sección recargada.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.RenaceLabs = { boot: boot };
})();

/* -----------------------------------------------------------------
   Recomendados del cajón del carrito.
   Agrega sin recargar y le pide a Shopify las secciones ya
   renderizadas, así el subtotal y el globo del ícono quedan al día.
   Delegado en document porque el cajón se reemplaza entero al agregar.
----------------------------------------------------------------- */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.rl-ups__form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('.rl-ups__add');
    var drawer = document.querySelector('cart-drawer');
    var original = btn ? btn.textContent : '';

    if (btn) {
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Agregando…';
    }

    /* En el cajón repintamos el cajón; en /cart repintamos la página del
       carrito. Si no reconocemos ninguno de los dos, recargamos: es feo
       pero nunca deja al cliente con un carrito que miente. */
    var objetivos = [];
    if (!drawer) {
      [
        { sel: '#main-cart-items', src: '#main-cart-items' },
        { sel: '#main-cart-footer', src: '#main-cart-footer' },
        /* El globo del ícono vuelve sin su <a> contenedor, así que
           de esa sección tomamos la envoltura completa. */
        { sel: '#cart-icon-bubble', src: '.shopify-section', id: 'cart-icon-bubble' },
      ].forEach(function (s) {
        var el = document.querySelector(s.sel);
        if (!el) return;
        s.id = s.id || el.dataset.id || s.sel.slice(1);
        objetivos.push(s);
      });
    }

    var body = new FormData(form);
    var ids = drawer
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : objetivos.map(function (s) { return s.id; });

    if (ids.length) {
      body.append('sections', ids.join(','));
      body.append('sections_url', window.location.pathname);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body,
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        if (!data.sections) { window.location.reload(); return; }

        if (drawer) {
          drawer.renderContents(data);
          return;
        }

        /* El contador del header no sale de ninguna sección de Dawn y
           /cart/add.js devuelve el ítem, no el carrito, así que el total
           hay que ir a buscarlo. */
        var contadores = document.querySelectorAll('[data-rl-cart-count]');
        if (contadores.length) {
          fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              contadores.forEach(function (el) {
                el.textContent = c.item_count;
                el.hidden = c.item_count === 0;
              });
            })
            .catch(function () {});
        }

        objetivos.forEach(function (s) {
          var html = data.sections[s.id];
          if (!html) return;
          var destino = document.querySelector(s.sel);
          var fuente = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(s.src);
          if (destino && fuente) destino.innerHTML = fuente.innerHTML;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {
        if (btn) {
          btn.textContent = 'No se pudo agregar';
          setTimeout(function () {
            btn.textContent = original;
            btn.removeAttribute('aria-busy');
          }, 2200);
        }
      });
  });
})();
